import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { DetailActionTypeEnum, useDetailModel } from "./detailModel";

export const InfoBox = () => {

    const {
        actionType, title,
        setActionType,
    } = useDetailModel();

    const classname = (type: DetailActionTypeEnum) => {
        return 'tab-item ' + (actionType === type ? 'tab-active' : '')
    }

    const action = (
        <>
            <div>
                <Button
                    className={classname(DetailActionTypeEnum.STATEMENT)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.STATEMENT)}>
                    对账单
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.BILL)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.BILL)}>
                    账单
                </Button>
            </div>
        </>
    );
    return (
        <YhBox
            title={title}
            action={action}
        />
    )
}
